<template>
  <div>
    <validation-provider
        v-slot="validationContext"
        name="Başlık"
        rules="required"
      >
    <b-form-group label="Başlık" label-for="smsTitle">
      <b-form-input
        id="smsTitle"
        v-model="localValue.campaign_name"
        @input="emitUpdate"
        :state="getValidationState(validationContext)"
      />
      <b-form-invalid-feedback>
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
    <b-row class="mb-2">
      <b-col cols="6" v-if="localValue.description">
        <b-card title="Önizleme">
          <p v-html="smsPreview"></p>
          <small class="text-muted" v-if="localValue.type == 2">
            {{ characterCount }} Karakter / {{ smsPartCount }} Kontör
          </small>
        </b-card>
      </b-col>
      <b-col cols="6" v-if="localValue.inf_id">
        <b-button type="button" variant="outline-secondary" @click="$emit('edit-sms')">
          {{ localValue.description ? 'Metni düzenle' : 'Metin ekle' }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInvalidFeedback
} from 'bootstrap-vue'
  import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInvalidFeedback,
    ValidationProvider
  },
  props: {
    linkData: { type: Object, required: true }
  },
  data() {
    return {
      localValue: { ...this.linkData }
    }
  },
  watch: {
    linkData: {
      handler(newVal) {
        this.localValue = { ...newVal }
      },
      deep: true
    }
  },
  computed: {
    smsPreview() {
      if (!this.localValue.description) return ''
      const link = this.localValue.short_url || ''
      return this.localValue.description.replace('{#link#}', `<a href="${link}">${link}</a>`)
    },
    characterCount() {
      return this.smsPreview.length
    },
    smsPartCount() {
      return Math.ceil(this.characterCount / 160)
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update', { ...this.localValue })
    },
    
    getValidationState(context) {
        if (context) return context.validated ? !context.invalid : null
        return null
      }
  }
}
</script>